import { imageLoaderStoryblok as imageLoader } from '~/components/Abstracts/Image/loader'

export type Image = {
  src: string
  width: number
  height: number
  alt?: string
}

export type ImageOptions = {
  filename?: string
  src?: string
  alt?: string
  name?: string
}

export type LoaderParams = {
  width: number
  quality: number
}

/**
 * Image serializer
 * @param image
 * @param loaderParams
 * @returns Serialized image
 */
export default function serializeImage(
  image: ImageOptions,
  loaderParams?: LoaderParams,
): Image {
  const src = image?.filename ?? image?.src
  const alt = image?.alt ?? null
  let newImageSrc: string

  const [width, height] = src ? src.split('/')[5].split('x') : []

  const dimensions = {
    width: width ? parseInt(width) : null,
    height: height ? parseInt(height) : null,
  }

  if (src) {
    const url = new URL(src)
    newImageSrc = `${url?.origin}${url?.pathname}`

    newImageSrc =
      loaderParams && src.indexOf('.svg') === -1
        ? imageLoader({
            src: newImageSrc,
            ...loaderParams,
          })
        : newImageSrc
  }

  return src
    ? {
        src: newImageSrc ?? src,
        width: dimensions?.width,
        height: dimensions?.height,
        alt,
      }
    : null
}
